/** Thrown when the live document no longer matches what QC saw (edited since the run finished) —
 * callers must show this as "re-run QC", never silently apply a fix against stale assumptions. */
export class FixDriftError extends Error {}
